"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotesReducer = exports.GetNotesSelector = exports.NotesReady = exports.NotesDelete = exports.NotesEdit = exports.NotesAdd = exports.NOTES_READY = exports.NOTES_DELETE = exports.NOTES_EDIT = exports.NOTES_ADD = void 0;
const tslib_1 = require("tslib");
const AdaptableHelper_1 = tslib_1.__importDefault(require("../../Utilities/Helpers/AdaptableHelper"));
const GeneralConstants_1 = require("../../Utilities/Constants/GeneralConstants");
/**
 * @ReduxAction A Notes has been added
 */
exports.NOTES_ADD = 'NOTES_ADD';
/**
 * @ReduxAction A Notes has been edited
 */
exports.NOTES_EDIT = 'NOTES_EDIT';
/**
 * @ReduxAction A Notes has been deleted
 */
exports.NOTES_DELETE = 'NOTES_DELETE';
/**
 * @ReduxAction Notes Module is ready
 */
exports.NOTES_READY = 'NOTES_READY';
const NotesAdd = (note) => ({
    type: exports.NOTES_ADD,
    adaptableNote: note,
});
exports.NotesAdd = NotesAdd;
const NotesEdit = (note) => ({
    type: exports.NOTES_EDIT,
    adaptableNote: note,
});
exports.NotesEdit = NotesEdit;
const NotesDelete = (note) => ({
    type: exports.NOTES_DELETE,
    adaptableNote: note,
});
exports.NotesDelete = NotesDelete;
const NotesReady = (note) => ({
    type: exports.NOTES_READY,
    notesState: note,
});
exports.NotesReady = NotesReady;
const GetNotesSelector = (state, config) => {
    var _a, _b;
    if (!config) {
        return (_a = state === null || state === void 0 ? void 0 : state.Notes) !== null && _a !== void 0 ? _a : [];
    }
    return ((_b = state === null || state === void 0 ? void 0 : state.Notes) !== null && _b !== void 0 ? _b : []).filter((note) => {
        if (note.PrimaryKeyValue === config.PrimaryKeyValue && note.ColumnId === config.ColumnId) {
            // happy check
            return true;
        }
        // Primary keys retreived from the grid dom are always strings, so we must also consider them strings
        if ((typeof config.PrimaryKeyValue === 'number' && typeof note.PrimaryKeyValue === 'string') ||
            (typeof config.PrimaryKeyValue === 'string' && typeof note.PrimaryKeyValue === 'number')) {
            return (note.PrimaryKeyValue.toString() === config.PrimaryKeyValue.toString() &&
                note.ColumnId === config.ColumnId);
        }
        return false;
    });
};
exports.GetNotesSelector = GetNotesSelector;
const initialState = {
    Notes: GeneralConstants_1.EMPTY_ARRAY,
};
const NotesReducer = (state = initialState, action) => {
    let adaptableNotes;
    switch (action.type) {
        case exports.NOTES_ADD: {
            const note = action.adaptableNote;
            AdaptableHelper_1.default.addUuidAndSource(note);
            adaptableNotes = [].concat(state.Notes);
            adaptableNotes.push(note);
            return Object.assign(Object.assign({}, state), { Notes: adaptableNotes });
        }
        case exports.NOTES_EDIT: {
            const note = action.adaptableNote;
            return Object.assign(Object.assign({}, state), { Notes: state.Notes.map((abObject) => (abObject.Uuid === note.Uuid ? note : abObject)) });
        }
        case exports.NOTES_DELETE: {
            const note = action.adaptableNote;
            return Object.assign(Object.assign({}, state), { Notes: state.Notes.filter((abObject) => abObject.Uuid !== note.Uuid) });
        }
        default:
            return state;
    }
};
exports.NotesReducer = NotesReducer;
